(() => {
    "use strict";

    const mapSection = document.getElementById('mapLoader');
    
    // Safety check matching your lightbox pattern - exit early if not on this page
    if (!mapSection) return;

    const mapUrl = mapSection.getAttribute('data-map-url');
    const canvasWrapper = mapSection.querySelector('.map-block__canvas-wrapper');
    const loadingState = mapSection.querySelector('.map-block__loading-state');

    const observerOptions = {
        root: null,
        rootMargin: '200px', 
        threshold: 0
    };

    const loadMap = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (mapUrl && canvasWrapper) {
                    const iframe = document.createElement('iframe');
                    iframe.setAttribute('src', mapUrl);
                    iframe.setAttribute('allowfullscreen', '');
                    iframe.setAttribute('title', 'Interactive Google Map');

                    iframe.addEventListener('load', () => {
                        iframe.classList.add('is-loaded');
                        
                        if (loadingState) {
                            loadingState.style.opacity = '0';
                            setTimeout(() => loadingState.remove(), 400);
                        }
                    });

                    iframe.onerror = () => {
                        console.error("Google Map failed to build.");
                        if (loadingState) {
                            loadingState.innerHTML = '<span style="color:#5f6368; font-family:sans-serif;">Map failed to load.</span>';
                        }
                    };

                    canvasWrapper.appendChild(iframe);
                }

                observer.unobserve(entry.target);
            }
        });
    };

    const observer = new IntersectionObserver(loadMap, observerOptions);
    observer.observe(mapSection);
})();